// ABOUTME: Generic debounce hook for delaying rapid state updates (e.g. search input).
// ABOUTME: Returns the debounced value after the specified delay in milliseconds.
import {useEffect, useState} from 'react'

export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debouncedValue
}
